import { CakeBirthdayLight } from '@ha/icons';
import { units, Typography } from '@hbf/dsl';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useIntl } from 'ha/i18n';
import { UserEntity } from 'ha/types/UserEntity';
import { formatAge } from 'ha/utils/formatAge';

const useStyles = makeStyles()(() => ({
  root: {
    padding: units.yx(0, 1),
  },
  icon: {
    fontSize: units.rem(0.75),
    marginRight: units.rem(0.5),
  },
}));

interface Props {
  birthDate: UserEntity['birthDate'];
}

const UserCardAge: React.FC<Props> = ({ birthDate }) => {
  const { classes } = useStyles();
  const { T } = useIntl();

  if (!birthDate) {
    return null;
  }

  return (
    <Typography.Caption
      className={classes.root}
      overflow="ellipsis"
      data-test-locator="User Card Age"
    >
      <CakeBirthdayLight className={classes.icon} fontSize="small" />
      {T('%d years old', formatAge(birthDate))}
    </Typography.Caption>
  );
};

export { UserCardAge };
